import PrintButton from './PrintButton';

export default PrintButton;



// WEBPACK FOOTER //
// ./src/components/PrintButton/index.js